import { SearchableListSelect } from './SearchableListSelect';
import { useVenues } from '../../hooks/useVenues';

export interface VenueSelectProps {
  /** Selected venue id (null = none). */
  value: string | null;
  onChange: (venueId: string | null) => void;
  disabled?: boolean;
  placeholder?: string;
  ariaLabel?: string;
}

/** Searchable picker over the active venues, with the city as a subtitle. */
export function VenueSelect({
  value,
  onChange,
  disabled,
  placeholder = 'Select venue',
  ariaLabel = 'Venue',
}: VenueSelectProps) {
  const { data: venues = [], isLoading } = useVenues({ isActive: true });
  return (
    <SearchableListSelect
      items={venues}
      value={value}
      onChange={(next) => onChange(typeof next === 'string' && next ? next : null)}
      getValue={(venue) => venue.id}
      getLabel={(venue) => venue.name}
      getSubtitle={(venue) => venue.city}
      isLoading={isLoading}
      disabled={disabled}
      placeholder={placeholder}
      ariaLabel={ariaLabel}
    />
  );
}
